module.exports = __webpack_public_path__ + "static/media/Atlantic_Road_Bergen_Norway_2.6ef73355.jpg";